/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Login200Response
 */
export interface Login200Response {
    /**
     * ステータス
     * @type {number}
     * @memberof Login200Response
     */
    status: number;
    /**
     * メッセージ
     * @type {string}
     * @memberof Login200Response
     */
    message: string;
    /**
     * 認証トークン
     * @type {string}
     * @memberof Login200Response
     */
    adminToken: string;
    /**
     * 企業タイプ 0:一般 1:運営
     * @type {number}
     * @memberof Login200Response
     */
    companyType: number;
}

/**
 * Check if a given object implements the Login200Response interface.
 */
export function instanceOfLogin200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "adminToken" in value;
    isInstance = isInstance && "companyType" in value;

    return isInstance;
}

export function Login200ResponseFromJSON(json: any): Login200Response {
    return Login200ResponseFromJSONTyped(json, false);
}

export function Login200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Login200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'adminToken': json['admin_token'],
        'companyType': json['company_type'],
    };
}

export function Login200ResponseToJSON(value?: Login200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'admin_token': value.adminToken,
        'company_type': value.companyType,
    };
}

